module.exports = __webpack_public_path__ + "static/media/logoTeamsGrey.c8a86363.svg";